module.exports = __webpack_public_path__ + "img/team-delivery-bg.3d5abc57.svg";